import { useState } from "react";

import ClearStorageConfirmationModal from "../../../components/clear-storage-confirmation-modal";
import CustomButton from "../../../components/custom-button";

import * as Storage from "../../../utils/storage";

const SurveySettingsScreen = () => {
  const [modalIsVisible, setModalIsVisible] = useState(false);

  const surveyRespondentData = Storage.getItem("surveyRespondentData");
  const surveyData = Storage.getItem("survey");

  const { answers, questionsVisibility } = surveyData;

  const onConfirmedClearStorage = () => {
    Storage.clear();
  };

  const onClickClearSession = (event) => {
    event.preventDefault();
    setModalIsVisible(true);
  };

  const onCloseModal = () => setModalIsVisible(false);

  return (
    <>
      <ClearStorageConfirmationModal
        onAccepted={onConfirmedClearStorage}
        isVisible={modalIsVisible}
        onCloseModal={onCloseModal}
      />
      <h1 className="pt-2 mb-4">Ajustes</h1>
      <div className="card mb-4">
        <div className="card-header">Tu sesión actual</div>
        <div className="card-body">
          <div className="d-flex flex-row align-items-center justify-content-center">
            <div className="flex-grow-1 mr-4">
              Si presentas dificultades para completar un formulario o encuentras preguntas que ya
              venían respondidas incluso antes de iniciar el cuestionario, puede ser que una sesión
              de una encuesta anterior almacenada en tu navegador está causando problemas. Una
              solución para eso es eliminar el almacenamiento local de esta página en tu navegador
              puede solucionar el problema.
            </div>
            <CustomButton
              additionalClasses="align-self-center text-nowrap"
              onClick={onClickClearSession}
              text="Borrar la sesión actual"
              color="red"
              noIcon
            />
          </div>
        </div>
      </div>
      <div className="card mb-4">
        <div className="card-header">Tu almacenamiento local</div>
        <div className="card-body">
          <div className="text-lg">Datos del encuestado</div>
          <div className="mb-2">{JSON.stringify(surveyRespondentData)}</div>
          <div className="text-lg">Datos de la encuesta</div>
          <div>{JSON.stringify(answers)}</div>
          <div>{JSON.stringify(questionsVisibility)}</div>
        </div>
      </div>
    </>
  );
};

export default SurveySettingsScreen;
